import PageHero from "../components/PageHero";

const PRESS = [
  {
    date: "2025-07-12",
    outlet: "Hospitality Investor",
    title: "Nomad Livings Launches Modular A-Frame Villas for Hospitality Investors",
    excerpt: "The new platform offers five villa configurations designed for staycations, Airbnb rentals and boutique resorts across India's leisure destinations.",
  },
  {
    date: "2025-05-03",
    outlet: "Realty Weekly",
    title: "Govianu Group Enters Experiential Hospitality with Nomad Livings",
    excerpt: "Fifteen years of real estate expertise meets modular construction in a bid to reshape India's nature-first accommodation market.",
  },
  {
    date: "2025-02-20",
    outlet: "The Investor Post",
    title: "Why A-Frame Villas Are India's Hottest New Hospitality Asset",
    excerpt: "Nomad Livings' modular system delivers 28-40% annual ROI with payback in 2.5-4 years, attracting NRI and HNI investors alike.",
  },
  {
    date: "2024-11-08",
    outlet: "NRI Finance Today",
    title: "NRIs Find Passive Income in India's Booming Staycation Market",
    excerpt: "Professionally managed A-frame villas let overseas investors own a tangible holiday home while earning rental returns year-round.",
  },
];

const MEDIA_KIT = [
  { icon: "ri-file-pdf-2-line", label: "Company Fact Sheet" },
  { icon: "ri-user-voice-line", label: "Founder Bio & Headshots" },
  { icon: "ri-image-2-line", label: "Logo & Brand Assets" },
  { icon: "ri-presentation-line", label: "Product Overview Deck" },
];

export default function Press() {
  return (
    <div className="w-full">
      <PageHero
        eyebrow="Press & Media"
        title={
          <>
            In the <span className="italic text-accent-300">News</span>
          </>
        }
        subtitle="Latest announcements, coverage and resources for journalists and partners covering Nomad Livings."
      />

      <section className="w-full py-12 md:py-16 bg-background-50">
        <div className="w-full px-4 md:px-8 max-w-5xl mx-auto">
          <div className="space-y-4">
            {PRESS.map((p) => (
              <a
                key={p.title}
                href="/contact"
                className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 rounded-2xl bg-background-100 border border-background-200 p-5 hover:border-primary-300 hover:-translate-y-0.5 transition-all duration-300"
              >
                <div>
                  <p className="text-[11px] font-semibold uppercase tracking-wide text-primary-600">
                    {p.outlet} · {p.date}
                  </p>
                  <h3 className="font-heading text-lg text-foreground-950 mt-1.5">{p.title}</h3>
                  <p className="text-sm text-foreground-600 mt-1">{p.excerpt}</p>
                </div>
                <span className="flex items-center gap-1.5 text-sm font-semibold text-primary-700 whitespace-nowrap">
                  Read <i className="ri-arrow-right-line"></i>
                </span>
              </a>
            ))}
          </div>

          <div className="mt-12 rounded-2xl bg-primary-100 border border-primary-200 p-6 md:p-8">
            <h3 className="font-heading text-xl text-foreground-950">Media Kit</h3>
            <p className="text-sm text-foreground-700 mt-1">
              Request our media kit for interviews, quotes and brand assets.
            </p>
            <div className="mt-5 grid grid-cols-2 md:grid-cols-4 gap-3">
              {MEDIA_KIT.map((m) => (
                <div
                  key={m.label}
                  className="flex items-center gap-2.5 rounded-xl bg-background-50 border border-background-200 px-3 py-3"
                >
                  <span className="flex items-center justify-center w-9 h-9 rounded-lg bg-primary-100 text-primary-700 shrink-0">
                    <i className={`${m.icon} text-lg`}></i>
                  </span>
                  <span className="text-xs font-medium text-foreground-800">{m.label}</span>
                </div>
              ))}
            </div>
            <a
              href="mailto:press@nomadlivings.com"
              className="inline-flex items-center gap-2 text-sm font-semibold whitespace-nowrap rounded-full bg-primary-600 text-background-50 px-6 py-3 mt-6 hover:bg-primary-700 transition-colors"
            >
              <i className="ri-mail-send-line"></i> press@nomadlivings.com
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}